import React from 'react'; 
import config from '../appconfig/config.json';
import scaImg from '../images/sgdAcct.png';
import faImg from '../images/flexiAcct.png';
import paImg from '../images/preAcct.png';
import { Button } from "@progress/kendo-react-buttons"; 
// import '../styles/card-style.css'

const photoNote = {
    textTransform: 'uppercase',
    fontSize:'0.8em',
    color:'#171717',
    paddingTop:'15px'
} 

const despNote = {
    color:'#7d7d7d', fontSize:'0.8em',paddingTop:'5px'
}

const btnStyle = {
    width:'100%',
    marginTop:'10px',
    fontSize:'0.7em',
    color:'#212529'
}

const greenBtnStyle ={
    width:'100%',
    marginTop:'10px',
    fontSize:'0.6em'
}


const OpenSMEAcct = () => {

    const prodTypeFA = 'FA', prodTypePA = 'PA', prodTypeSCA = 'SCA';
    
   const onhandleDiscoverClick = (prodType) => {
    
        if(prodType === prodTypeFA) {
            window.location.href = config.link.SMEFA;
        }
    
        if(prodType === prodTypePA) {
            window.location.href = config.link.SMEPA;
        }
    
        if(prodType === prodTypeSCA) {
            window.location.href = config.link.SMESCA;
        }
   }

   const onHandleOpenAcctClick = (prodType) => {
    if(prodType === prodTypeFA) {
        window.location.href = config.link.SMEFA;
    }

    if(prodType === prodTypePA) {
        window.location.href = config.link.SMEPA;
    }

    if(prodType === prodTypeSCA) {
        window.location.href = config.link.SMESCA;
    }
   }
 

    return(
        <div>
            <div style={{textAlign:'center',color:'#585858'}}>
                <div style={{fontWeight:'500',fontSize:'1.5em'}}>
                    {'Open an Account'}
                </div>
                <div>
                    {'Open a current account now to receive your funds.'}
                    <br />
                    {'Please select any one of our three current account types.'}
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1"></div>
                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3"
                    style={{margin:'10px',padding:'10px',boxShadow:'0 0 10px 0 rgb(0 0 0 / 20%)'}}>

                    <img style={{width:'100%'}} src={faImg} alt="flexImg" />
                    <span style={photoNote}>
                        FlexiBiz Account 
                    </span>
                    <div style={despNote}>
                    
                         <p>Offers zero monthly fee, free access to business internet banking, all-in-one business debit card and attractive interest rates for startups and young businesses.</p>
                          
                         <span>MORE BENEFITS&nbsp;<span className="k-icon k-i-arrow-chevron-right" /></span>
                    </div>
                    <div style={{width:'100%',padding:'10px'}} >
                        <Button look="outline" style={btnStyle} onClick={(e)=> onhandleDiscoverClick(prodTypeFA)}><strong>DISCOVER</strong></Button> 
                        <Button className="k-button btn btn-success" style={greenBtnStyle} onClick={(e)=> onHandleOpenAcctClick(prodTypeFA)}><strong>OPEN AN ACCOUNT</strong></Button>
                    </div>
                </div>

                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3" 
                    style={{margin:'10px',padding:'10px',boxShadow:'0 0 10px 0 rgb(0 0 0 / 20%)'}}>
                    <img style={{width:'100%'}} src={paImg} alt="paImg" />
                    <span style={photoNote}>
                        PREMIERBIZ ACCOUNT
                    </span>
                    <div style={despNote}>
                         <p>Takes your business to the next level with ease of digital payments, transaction rebates and attractive interest rates.</p>
                          <br/>
                         <span>MORE BENEFITS&nbsp;<span className="k-icon k-i-arrow-chevron-right" /></span>
                    </div>
                    <div style={{width:'100%',padding:'10px'}} >
                        <Button look="outline" style={btnStyle} onClick={(e)=> onhandleDiscoverClick(prodTypePA)}><strong>DISCOVER</strong></Button> 
                        <Button className="k-button btn btn-success" style={greenBtnStyle} onClick={(e)=> onHandleOpenAcctClick(prodTypePA)}><strong>OPEN AN ACCOUNT</strong></Button>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3"
                    style={{margin:'10px',padding:'10px',boxShadow:'0 0 10px 0 rgb(0 0 0 / 20%)'}}>
                    <img style={{width:'100%'}} src={scaImg} alt="flexImg" />
                    <span style={photoNote}>
                        SINGAPORE DOLLAR CURRENT ACCOUNT
                    </span>
                    <div style={despNote}>
                      
                         <p>A basic non-interest bearing Current Account with convenience of Free Business Internet Banking Services 24/7.</p>
                          
                         <span>MORE BENEFITS&nbsp;<span className="k-icon k-i-arrow-chevron-right" /></span>
                    </div>
                    <div style={{width:'100%',padding:'10px'}} >
                    <Button look="outline" style={btnStyle} onClick={(e)=> onhandleDiscoverClick(prodTypeSCA)}><strong>DISCOVER</strong></Button> 
                        <Button className="k-button btn btn-success" style={greenBtnStyle} onClick={(e)=> onHandleOpenAcctClick(prodTypeSCA)}><strong>OPEN AN ACCOUNT</strong></Button>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1"></div>
            </div>
          
          
        </div>
    )
}

export default OpenSMEAcct